import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import MobilePopup from './MobilePopup';
import Popup from './Popup';
import { useRouter } from 'next/router';
import { getDynamicPopups } from '../../new-lib/apis';

export interface DynamicPopupsContainerProps {
  handleClose?: () => void;
  handleShow?: () => void;
}

const DynamicPopupsContainer = () => {
  const { asPath } = useRouter();
  const isMobile = useSelector((state: any) => state.app.isMobile);
  const countryCode = useSelector(
    (state: any) => state.app.userLocation?.countryCode
  );

  const [displayPopup, setDisplayPopup] = useState(false);
  const [allPopups, setAllPopups] = useState<any[]>([]);
  const [shownPopup, setShownPopup] = useState<any>(null);

  useEffect(() => {
    const fetchPopups = async () => {
      const data = await getDynamicPopups();
      setAllPopups(data);
    };
    fetchPopups();
  }, []);

  useEffect(() => {
    const filteredPopups = allPopups?.filter((popup: any) =>
      popup.countries?.includes(countryCode)
    );

    const matchingPopup = filteredPopups.find(
      (popup: any) => popup.page === asPath
    );

    if (matchingPopup) {
      setShownPopup(matchingPopup);
    }
  }, [allPopups, asPath]);

  const handleClose = () => {
    document.querySelector('#dynamic-popup-modal')?.classList.add('disappear');
    document.querySelector('#dynamic-popup')?.classList.add('remove-overlay');

    setDisplayPopup(false);
  };

  useEffect(() => {
    if (!shownPopup?.duration) return;

    const timeout = setTimeout(() => {
      handleClose();
    }, shownPopup.duration * 1000);

    return () => clearTimeout(timeout);
  }, [shownPopup, handleClose]);

  useEffect(() => {
    const shouldDisplayPopup = localStorage.getItem(
      `showPopup:${shownPopup?.id}`
    );
    setDisplayPopup(
      shouldDisplayPopup === null || shouldDisplayPopup === 'true'
    );
  }, [shownPopup]);

  if (shownPopup === null || !displayPopup) {
    return null;
  }

  return isMobile ? (
    <MobilePopup handleClose={handleClose} popups={shownPopup} />
  ) : (
    <Popup handleClose={handleClose} popups={shownPopup} />
  );
};

export default DynamicPopupsContainer;
